export const ROUTES = {
  index: '/',
  about: '/about',
  projects: '/projects',
  visualarts: '/projects/visualarts',
  userInterface: {
    ['portfol.io']: '/projects/portfol.io',
    ['spotlight']: '/projects/spotlight',
  },
  architecture: {
    ['foldPavilion']: '/projects/fold-pavilion',
    ['kineticBoardwalk']: '/projects/kinetic-boardwalk',
    ['basiliskTower']: '/projects/basilisk-tower',
  },
};

export const EXTERNAL_ROUTES = {
  saviForecasting: 'https://forecasting.financesavi.com/',
  centroBudgeting: 'https://web.getcentro.com/',
  rpgNodeBoard: 'https://github.com/elsonel/rpg-node-board',
};
